import { createFileRoute, Outlet } from "@tanstack/react-router";

// The console moved under /account. This route only exists so the old URLs
// still resolve — each child redirects to its new home.
export const Route = createFileRoute("/konsoll")({
	component: Outlet,
});
